export default __webpack_public_path__ + "static/media/twitter-brands (1).5fdb9b3c.svg";